/* eslint-disable max-len */
import React from 'react';

const ParagraphIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path
      fill="currentColor"
      d="M7.75 14.996V11.16h2.66c.71 0 1.288-.1 1.736-.301.448-.2.793-.455 1.036-.763s.408-.642.497-1.001c.089-.36.133-.693.133-1.001 0-.308-.044-.644-.133-1.008-.089-.364-.254-.7-.497-1.008-.243-.308-.588-.565-1.036-.77C11.698 5.103 11.119 5 10.41 5H6v9.996h1.75zm2.562-5.264H7.75V6.428h2.59c.233 0 .453.023.658.07.205.047.387.133.546.259.159.126.285.296.378.511.093.215.14.485.14.812 0 .317-.054.581-.161.791-.107.21-.247.378-.42.504s-.362.217-.567.273c-.205.056-.406.084-.602.084z"
    />
  </svg>
);

export default ParagraphIcon;
